import { Component, Fragment } from "react";
import {
  DKLabel,
  DKButton,
  DKLine,
  DKIcons,
  showAlert,
  showLoader,
  removeLoader
} from "deskera-ui-library";
import AutomationManager from "../AutomationManager";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
} from "../../../managers/TableManger";
import ic_tick_green from "../../../assets/automation/ic_tick_green.png";
import ic_cross_red from "../../../assets/automation/ic_cross_red.png";
// import { PipelineManager } from "../../../managers/PipelineManager";
import {
  AUTOMATION_ACTIONS,
  AUTOMATION_ELEMENT,
  AUTOMATION_TRIGGERS,
  CONNECTOR_DIMENSION,
  SPLIT_CONSTANT,
  STEP_CARD_WIDTH,
} from "../AutomationConstants";
import { PipelineManager } from "../../../managers/PipelineManager";
import FormatCurrencyService from "../../../services/FormatCurrencyService";
import i18next from "i18next";
import { connect } from "react-redux";
import { fetchEmployeeListWithoutFilter } from "../../../Redux/Slices/EmployeeListSlice";
import EmployeeManager, { getReportingManagerOptions } from "../../add-employee/steps/Employee";
/*
PROPS
- stepIndex
- stepData (step data)
- splitDimensions
- removeAddActionOption
- parentType
- onEdit
- onDelete
- onAddButtonClick
*/

class Step extends Component {
  pipelineDetails = PipelineManager.processPipelineData();

  constructor(props) {
    super(props);

    this.state = {
      reportingManagers: []
    }
  }

  componentDidMount() {
    this.getData();
  }

  render() {
    const { stepIndex, stepData, splitDimensions, leftChild, rightChild } =
      this.props;
    return (
      <div className="column align-items-center" id={`auto-step-${stepIndex}`}>
        {this.renderStepCard(stepData)}
        {stepData.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW ? (
          <Fragment>
            <DKLine className="bg-gray4" style={{ ...CONNECTOR_DIMENSION }} />
            <div
              className={`row justify-content-${splitDimensions.justifyWings} align-items-start`}
              style={{ width: 2 * splitDimensions.stepWidth }}
            >
              <div
                className="column align-items-center position-relative"
                style={{
                  width: splitDimensions.stepWidth,
                  flexShrink: 0,
                  paddingRight: splitDimensions.leftWingPadding,
                }}
              >
                <DKButton
                  className="bg-chip-green shadow-m border-radius-l border-green position-absolute text-green unselectable z-index-3"
                  style={{
                    top: -18,
                    right: "10%",
                  }}
                  title="YES"
                  icon={ic_tick_green}
                  onClick={() => {}}
                />
                <DKLine
                  className="bg-gray4 position-absolute width-auto"
                  style={{
                    top: 0,
                    right: 0,
                    height: CONNECTOR_DIMENSION.width,
                    width: splitDimensions.leftWingHangerWidth,
                  }}
                />
                {this.renderPlusButton(0)}
                {leftChild}
              </div>
              <div
                className="column align-items-center position-relative"
                style={{
                  width: splitDimensions.stepWidth,
                  flexShrink: 0,
                  paddingLeft: splitDimensions.rightWingPadding,
                }}
              >
                <DKLine
                  className="bg-gray4 position-absolute width-auto"
                  style={{
                    top: 0,
                    left: 0,
                    height: CONNECTOR_DIMENSION.width,
                    width: splitDimensions.rightWingHangerWidth,
                  }}
                />
                <DKButton
                  className="bg-chip-red text-red border-radius-l border-red position-absolute shadow-m unselectable z-index-3"
                  style={{
                    top: -18,
                    left: "10%",
                  }}
                  title="NO"
                  icon={ic_cross_red}
                  onClick={() => {}}
                />
                {this.renderPlusButton(1)}
                {rightChild}
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {this.renderPlusButton(null)}
            {leftChild}
          </Fragment>
        )}
      </div>
    );
  }

  async getData() {
    if (this.props.stepData.type === AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED) {
      showLoader();
      try {
        await this.props.fetchEmployeeListWithoutFilter();
        if (this.props.allEmployees) {
          const reportingManagers = getReportingManagerOptions(this.props.allEmployees, null, false);
          EmployeeManager.setReportingManagers(reportingManagers);
          this.setState({
            reportingManagers: reportingManagers
          });
          removeLoader();
        }
      } catch (err) {
        removeLoader();
        EmployeeManager.setReportingManagers([]);
        this.setState({
          reportingManagers: []
        });
        showAlert("Error Occurred!", "Failed to fetch reporting managers.");
      }
    }
  }

  getStepInfo() {
    const { type: stepType, configuration: stepConfiguration } =
      this.props.stepData;
    switch (stepType) {
      case AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON:
        // return stepConfiguration.title;
        break;
      case AUTOMATION_ACTIONS.SEND_EMAIL:
        case AUTOMATION_ACTIONS.SEND_MESSAGE:
        return stepConfiguration.subject;
      case AUTOMATION_ACTIONS.WAIT_FOR_TIME:
        // case AUTOMATION_ACTIONS.WAIT_FOR_EMAIL:
        return AutomationManager.getWaitIntervals(
          stepConfiguration.intervalIndex,
          stepConfiguration.count
        );
      case AUTOMATION_ACTIONS.ASSIGN_ACCESS:
        return [
          AUTOMATION_ACTIONS.CREATE_DEAL,
          AUTOMATION_ACTIONS.UPDATE_DEAL,
        ].includes(this.props.parentType)
          ? "Deals"
          : "Contacts";
      case AUTOMATION_ACTIONS.END_WORKFLOW:
        return "Finish...";
      case AUTOMATION_ACTIONS.SPLIT_WORKFLOW:
        return "Split into two branches";
      case AUTOMATION_ACTIONS.DESIGNATION:
        return this.getDesignationInfo(stepConfiguration);
      case AUTOMATION_ACTIONS.CALCULATE_COMMISSION:
        return this.getCommissionInfo(stepConfiguration);
      default:
        break;
    }

    if (
      (stepType === AUTOMATION_ACTIONS.CREATE_CONTACT ||
        stepType === AUTOMATION_ACTIONS.UPDATE_CONTACT ||
        stepType === AUTOMATION_ACTIONS.CREATE_DEAL ||
        stepType === AUTOMATION_ACTIONS.UPDATE_DEAL ||
        stepType === AUTOMATION_TRIGGERS.VALUE_CHANGED ||
        stepType === AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON ||
        stepType === AUTOMATION_TRIGGERS.CONTACT_ADDED ||
        stepType === AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED) &&
      stepConfiguration?.fields
    ) {
      return this.getStepColumnInfo();
    }
    return null;
  }
  getStepColumnInfo() {
    const { type: stepType, configuration: stepConfiguration } =
      this.props.stepData;
      
      let info = "";
      let tableName = "";
      switch (stepType) {
        case AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED:
          tableName = TABLES.EMPLOYEE_LIST;
          break;
        default:
          tableName = TABLES.DEAL;
          break;
      }

      let columns;
      if (tableName === TABLES.EMPLOYEE_LIST) {
        columns = AutomationManager.filterEmployeeColumns();
        columns.forEach((column) => {
          if (column.id === "reportingManagerId") {
            column.options = this.state.reportingManagers;
          }
        });
      } else {
        columns = TableManger.getTableColumns(tableName);
      }

      if (tableName === TABLES.DEAL) {
        let fields = {};
        stepConfiguration.fields.forEach((field) => {
          let key = Object.keys(field)[0];
          fields[key] = field[key][0];
        });
        let pipelineColumnID = TableManger.getColumnId(
          TABLES.DEAL,
          COLUMN_CODE.DEAL.PIPELINE_ID
        );
        columns.forEach((column) => {
          if (column.columnCode === COLUMN_CODE.DEAL.PIPELINE_ID) {
            column.name = "Pipeline";
            column.options = this.pipelineDetails;
          }
          if (column.columnCode === COLUMN_CODE.DEAL.STAGE_ID) {
            column.name = "Stage";
            column.options = this.pipelineDetails.find(
              (pipeline) => pipeline.id === fields[pipelineColumnID]
            )?.stages;
          }
        });
      }
      let stepConfig
      if(stepConfiguration) {
           stepConfig = (stepConfiguration && stepConfiguration.fields) ? stepConfiguration.fields:stepConfiguration[0].fields
      }
      
      stepConfig?.forEach((data) => {
        let key = Object.keys(data)[0];
        let column = columns.find((column) => column.id === key);
        if (
          stepType === AUTOMATION_TRIGGERS.VALUE_CHANGED ||
          stepType === AUTOMATION_TRIGGERS.CONTACT_ADDED
        ) {
          info += `<b>${column.name}</b> ${data.opr === "eq" ? "==" : "=>"} ${
            TableManger.isSelectField(column)
              ? column.options.find((option) => option.id === data[key][0]).name
              : data[key]
          }<br>`;
        } else if(column) {
          info += `<b>${column.name}:</b> ${
            TableManger.isSelectField(column)
              ? column.options?.find((option) => option.id === data[key][0])?.name
              : data[key]
          }<br>`;
        } else if(key == 'nodeKey') {
          info = `<b>Designation:</b> ${info}`
        } else {
          info += `<b>${SPLIT_CONSTANT[key]?SPLIT_CONSTANT[key] +":":""} </b> ${data[key]} <br>`
        }
      });
      return info.slice(0, -2);
  }
  getDesignationInfo(config){
    let designations='';
    if(config) {
      designations = `<b>${i18next.t("DESIGNATION")}:</b>`
        designations += config.fields.map(r => {
          if(r.designation) {
           return ` ${r.designation}`
          } else {
            return ''
          }
        })
      designations = designations.replace(/,\s*$/, "");
    }
    return designations
  }
  getCommissionInfo(config){
    let commision='';
    if(config) {
      
      config.fields.forEach(r=>{
        if(r.flatAmount) {
          
          commision= `<b>${i18next.t("FLAT")}: </b> ${FormatCurrencyService.format(r.flatAmount)}`
        } else if(r.percentageOfDealCost){
          
          commision=  `<b>${i18next.t("PERCENTAGE")}: </b> ${r.percentageOfDealCost}%`
        } else {
          commision=''
        }
      })
    }
    return commision
  }
  renderStepCard(stepData) {
    const stepInfo = stepData?.configuration ? this.getStepInfo() : null;
    return (
      <div
        className="row border-m bg-white border-radius-r shadow-s p-h-r p-v-r unselectable justify-content-between position-relative auto-element-card"
        style={{
          width: STEP_CARD_WIDTH,
          flexShrink: 0,
        }}
      >
        <div className="row width-90">
          {stepData.elementType === AUTOMATION_ELEMENT.TRIGGER
            ? AutomationManager.getTriggerIcon(stepData.type)
            : AutomationManager.getActionIcon(stepData.type)}
          <div className="ml-m width-80">
            <DKLabel
              text={stepData.title}
              className={
                stepData.elementType === AUTOMATION_ELEMENT.TRIGGER
                  ? "fw-m fs-m text-app parent-width"
                  : "text-gray parent-width"
              }
            />
            {stepInfo ? (
              <DKLabel text={stepInfo} className="mt-xs" />
            ) : null}
          </div>
        </div>
        {this.renderStepControls()}
      </div>
    );
  }
  renderStepControls() {
    const { stepData, onEdit, onDelete } = this.props;
    return (
        <div className={`auto-element-control row bg-white position-absolute pr-s border-s border-radius-m shadow-s`}
            style={{
                width: "auto",
                top: -20,
                right: 10,
            }}
        >
        <DKButton
          icon={DKIcons.ic_edit}
          style={{ opacity: 0.4, paddingRight: 0 }}
          onClick={onEdit}
        />
        {stepData.elementType !== AUTOMATION_ELEMENT.TRIGGER && (
            <Fragment>
                <DKLine className="ml-s" style={{ width: 1, height: 20}} />
                <DKButton
                    icon={DKIcons.ic_delete}
                    style={{ opacity: 0.4, paddingRight: 0 }}
                    onClick={onDelete}
                />
            </Fragment>
        )}
      </div>
    );
  }
  renderPlusButton(splitIndex) {
    const { stepData, removeAddActionOption, onAddButtonClick } = this.props;

    return stepData.type !== AUTOMATION_ACTIONS.END_WORKFLOW ? (
      <div className={`column align-items-center width-auto`}>
        <div className="bg-gray4" style={{ ...CONNECTOR_DIMENSION }} />
        {removeAddActionOption ? null : (
          <DKButton
            className="bg-white shadow-s border-radius-l unselectable"
            icon={DKIcons.ic_add}
            onClick={
              onAddButtonClick
                ? () => {
                    onAddButtonClick(splitIndex || 0);
                  }
                : null
            }
          />
        )}
        <div className="bg-gray4" style={{ ...CONNECTOR_DIMENSION }} />
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => ({
	allEmployees: state?.employee?.formData?.employeeDetails || null
});

const mapDispatchToProps = (dispatch) => ({
  fetchEmployeeListWithoutFilter: () => dispatch(fetchEmployeeListWithoutFilter())
});

export default connect(mapStateToProps, mapDispatchToProps)(Step);
